import { useQuery } from '@tanstack/react-query';
import {
  COMPANY_PROFILE_DEFAULTS, LEGAL_PAGE_DEFAULTS,
  type LegalPageSlug, type PublicCompanyProfileResponse, type PublicLegalPageResponse,
} from '@mbbe/types';
import { apiFetch } from '../lib/apiClient';

export function useCompanyProfile() {
  const { data } = useQuery({
    queryKey: ['site', 'profile'],
    queryFn: ({ signal }) => apiFetch<PublicCompanyProfileResponse>('/site/profile', { signal }),
    staleTime: 5 * 60 * 1000,
  });
  return { ...COMPANY_PROFILE_DEFAULTS, ...data?.profile };
}

export function useLegalPage(slug: LegalPageSlug) {
  const { data } = useQuery({
    queryKey: ['site', 'legal-page', slug],
    queryFn: ({ signal }) => apiFetch<PublicLegalPageResponse>(`/site/legal-pages/${slug}`, { signal }),
    staleTime: 5 * 60 * 1000,
  });
  const defaults = LEGAL_PAGE_DEFAULTS[slug];
  const tr = data?.tr?.markdown.trim() ? data.tr : defaults.tr;
  // An empty English translation falls back as a whole, including its title.
  const en = data ? (data.en?.markdown.trim() ? data.en : tr) :
    (defaults.en.markdown.trim() ? defaults.en : tr);
  return { tr, en, updatedAt: data?.updatedAt ?? null };
}
